import { all } from 'redux-saga/effects';

import formListSaga from './FormList/saga';
import formEditorSaga from './FormEditor/saga';
import formClientSaga from './FormClient/saga';

export default function* rootSaga() {
  yield all([
    formListSaga(),
    formEditorSaga(),
    formClientSaga()
  ]);
}
